import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from 'components';

const FloatmenuCard = ({
  className,
  id,
  itemList,
}) => {
  return (
    <div id={id}
      className={`FloatmenuCard ${className ? className : ''}`}>
      {
        itemList.map((item, index) => {
          return (
            <div key={item.id ? item.id : index}
              className="FloatmenuCard__item"
              id={`float-menu-${item.code}`}
              onClick={item.func}>
              <Typography>
                {item.name}
              </Typography>
            </div>
          );
        })
      }
    </div>
  );
};

FloatmenuCard.propTypes = {
  id: PropTypes.string,
  itemList: PropTypes.arrayOf(PropTypes.object),
};

export default FloatmenuCard;